var exports = {
  "O3": "x31de4314--1eed32--underground",
  "dl": "x31de4314--1eed32--underground-station",
  "hm": "x31de4314--1eed32--from-underground-time",
};

module.exports = exports;
